import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { getListingsSortAsURLSearchParams } from './listings-api/getListingsSortAsURLSearchParams';
import { serializeFilterPath } from './serializeFilterPath';

type StoreToPageURLState = Pick<ReduxApplicationState, 'productsQuery'>;

export const appendNonFacetListingParams = (
  urlParams: URLSearchParams,
  state: StoreToPageURLState,
  page?: number,
): void => {
  const {
    productsQuery: { searchTerm, sortOptions = [] },
  } = state;
  const activeSortOption = sortOptions.find((option) => option.active);
  if (activeSortOption) {
    getListingsSortAsURLSearchParams(urlParams, activeSortOption);
  }

  // don't include page=1 as that is the default
  if (page && page > 1) {
    urlParams.set('page', page.toString());
  }

  if (searchTerm) {
    urlParams.set('term', searchTerm);
  }
};

/**
 * Returns the filter path segment (e.g. "/-/p/-10/c/blue") for the active facets.
 * Returns an empty string when no filters are active.
 */
export const adaptStoreToFilterPath = (state: StoreToPageURLState): string =>
  serializeFilterPath(state.productsQuery.facets);

/**
 * Returns non-facet query params only (sort, page, term).
 * Facet filters are now serialised into the URL path via adaptStoreToFilterPath.
 */
export const adaptStoreToPageURL = (state: StoreToPageURLState, page?: number): URLSearchParams => {
  const urlParams = new URLSearchParams();
  appendNonFacetListingParams(urlParams, state, page);
  return urlParams;
};
